/**
 * The level a paragraph opens a section at, or null. Word reports a table pending deletion with the style of the
 * heading after it, and the paragraph marks of a pending deletion as empty paragraphs in that style: neither is a
 * heading.
 */ export function sectionHeadingLevel(paragraph, thresholdLevel) {
    const level = Number(/^Heading([1-9])$/.exec(paragraph.styleBuiltIn)?.[1]) - 1;
    const isHeading = level >= 0 && level <= thresholdLevel && !paragraph.tableNestingLevel && paragraph.text.trim() !== "";
    return isHeading ? level : null;
}
/** The paragraph's outline level (1 to 9) when Word reports one, else its built-in Heading 1 to 9 style; null for body text. */ export function paragraphOutline(paragraph) {
    const level = paragraph.outlineLevel ?? Number(/^Heading([1-9])$/.exec(paragraph.styleBuiltIn)?.[1]);
    const isHeading = level >= 1 && level <= 9 && !paragraph.tableNestingLevel && paragraph.text.trim() !== "";
    return isHeading ? level : null;
}
